import { Avatar, Col, Divider, Row, Space } from "antd";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React from "react";

import OAuth2Service from "services/authentication/oauth2.service";
import Icon from "common/components/general/Icon";
import Text from "common/components/general/Text";
import { MAIN_PATH } from "scenes/main";
import { ORGANIZATION_PATH } from "scenes/main/scenes/organization";

const TRANSLATION_BASE_PATH = "_MAIN._LEFT_SIDE_MENU";

const getRoleIcon = () => {
	if (OAuth2Service.isOwner) {
		return "ri-user-star-line";
	} else if (OAuth2Service.isOwnerOrAdmin) {
		return "ri-admin-line";
	} else if (OAuth2Service.isTeacher) {
		return "ri-user-2-line";
	} else if (OAuth2Service.isStudent) {
		return "ri-user-line";
	}
	return "ri-user-line";
};

const getRoleTitle = (translate: (key: string) => string) => {
	if (OAuth2Service.isOwner) {
		return translate(`${TRANSLATION_BASE_PATH}._OWNER`);
	} else if (OAuth2Service.isAdmin) {
		return translate(`${TRANSLATION_BASE_PATH}._ADMIN`);
	} else if (OAuth2Service.isTeacher) {
		return translate(`${TRANSLATION_BASE_PATH}._TEACHER`);
	}
	return translate(`${TRANSLATION_BASE_PATH}._STUDENT`);
};

interface OrganizationInfoProps {
	hideMenu?: () => void;
}

export const OrganizationInfo = (props: OrganizationInfoProps) => {
	const currentUser = OAuth2Service.CurrentUser;
	const history = useHistory();
	const { t: translate } = useTranslation();

	return (
		<Row className="mobile__view__organization_info">
			<Col span={24}>
				<Row>
					<Col span={24} className="mb-12">
						<Space direction="vertical" size={12} align="center" className="full__width">
							<Avatar
								icon={<Icon type="ri-building-4-line" className="color-blue-6" />}
								className="organization__avatar"
								size={40}
							/>
							<Space direction="vertical" size={8} align="center" className="full__width">
								<Text fontSize="14" lineHeight="22" className="color-gray-9">
									{currentUser?.Organizations[0]?.Name}
								</Text>
								<Space
									direction="horizontal"
									size={4}
									align="center"
									className="organization__role_title_content"
								>
									<Icon type={getRoleIcon()} className="color-blue-6" fontSize="14" />
									<Text fontSize="12" lineHeight="20" className="color-blue-6">
										{getRoleTitle(translate)}
									</Text>
								</Space>
							</Space>
						</Space>
					</Col>
					{OAuth2Service.isOwnerOrAdmin ? (
						<>
							<Divider orientation="center" type="horizontal" className="mt-0 mb-12" />
							<Col
								span={24}
								onClick={() => {
									props.hideMenu && props.hideMenu();
									history.push(`/${MAIN_PATH}/${ORGANIZATION_PATH}`);
								}}
							>
								<Space align="center" size={8} className="go__to_manage_button">
									<Icon type="ri-settings-4-line" className="color-gray-8" fontSize="16" />
									<Text fontSize="14" lineHeight="22" className="color-gray-8">
										{translate(`${TRANSLATION_BASE_PATH}._MANAGE`)}
									</Text>
								</Space>
							</Col>
						</>
					) : null}
				</Row>
			</Col>
		</Row>
	);
};
